module.exports = __webpack_public_path__ + "img/dining_room.be5030ca.webp";